import environment from "../environment.json";
import ApiResponseV2 from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/ApiResponseV2";
import Image from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/Image";
import HttpClientV2 from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/utils/HttpClientV2";

/**
 * Uploads images through OPS's own endpoint instead of core's `/images/upload`,
 * which fails because of competing @PreAuthorize annotations in core's ImageController.
 * Same request/response shape as core's ImageService.uploadImage.
 */
class OpsImageService {
  constructor(private basePath: string) {}

  private obtainExtension(file: File): string {
    return "." + file.name.split(".").slice(-1).pop();
  }

  uploadImage(file: File | Blob, fileName: string): Promise<ApiResponseV2<Image>> {
    const formData = new FormData();
    const fileExtension = file instanceof File ? this.obtainExtension(file) : "";

    formData.append("file", file, `${fileName}${fileExtension}`);

    return HttpClientV2.post(`${this.basePath}/upload`, formData);
  }
}

export default new OpsImageService(`${environment.baseURL}/ensolvers-ops/images`);
